import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import moment from 'moment';
import { CommonService } from '../../../../services/common/common.service';
import { ReviewsDataService, ReviewsColumnsService } from '../../../services';
import { Review, ReviewsResult } from '../../../interfaces';

@Component({
  selector: 'app-review-form',
  templateUrl: './review-form.component.html',
  styleUrls: ['./review-form.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class ReviewFormComponent implements OnInit, OnDestroy, AfterViewInit {

  public review: Review = {};
  public reviewForm: FormGroup = new FormGroup({});
  public reviews: Review[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public redirect = true;
  public disableSubmit = false;
  public enableFormAlert = true;


  constructor(
    private translate: TranslateService,
    public common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private reviewsDataService: ReviewsDataService,
    public reviewsColumnsService: ReviewsColumnsService,
  ) {
  }

  ngOnInit(): void {
    console.log('ngOnInit', 'ReviewFormComponent');
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Review - Edit');
        this.getReview(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.review !== 'undefined') {
      this.review = this.dynamicDialogConfig.data.review;
    }
    if (typeof this.review.id === 'undefined' || this.review.id === null) {
      this.review.id = null;
    }
    this.getReviews();
    this.prepareFrom();
  }

  ngOnDestroy(): void {
    console.log('ngOnDestroy', 'ReviewFormComponent');
  }

  ngAfterViewInit(): void {
    console.log('ngAfterViewInit', 'ReviewFormComponent');
  }

  getReview(id: number): void {
    this.isLoading = true;
    this.reviewsDataService.getReview(id).subscribe((response: Review|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.review = response;
        this.prepareFrom();
      }
    });
  }

  getReviews(): void {
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.reviews !== 'undefined' && this.dynamicDialogConfig.data.reviews.length > 0) {
      this.reviews = this.dynamicDialogConfig.data.reviews;
      return;
    }
    this.reviewsDataService.getReviews(this.parameters).subscribe((response: ReviewsResult|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.reviews = response.results;
      }
    });
  }

  prepareFrom(): void {
    this.reviewForm = new FormGroup({
      id: new FormControl(this.review.id, []),
      entity: new FormControl(this.review.entity, [Validators.required, ]),
      foreignKey: new FormControl(this.review.foreignKey, [Validators.required, ]),
      value: new FormControl(this.review.value, [Validators.required, ]),
      subject: new FormControl(this.review.subject, [Validators.required, ]),
      body: new FormControl(this.review.body, []),
      status: new FormControl(this.review.status, [Validators.required, ]),
    });
  }

  list() {
    this.router.navigate(['/reviews']);
  }

  showErrors() {
      this.showErrors();
      const invalidFields: string[] = [];
      Object.keys(this.reviewForm.controls).forEach((field: any) => {
        const control = this.reviewForm.get(field);
        if (control !== null) {
          control.markAsTouched({ onlySelf: true });
          if (control.invalid) {
            invalidFields.push(field);
          }
        }
      });
  }

  submitForm(redirect: boolean) {
    this.redirect = redirect;
    if (!this.reviewForm.valid) {
      this.showErrors();
    } else {
      this.saveData(redirect);
    }
  }

  saveData(redirect: boolean) {
    this.review = this.reviewForm.value;
    this.disableSubmit = true;
    console.log('review', this.review);
    if (typeof this.review.id !== 'undefined' && this.review.id !== null) {
      this.add(redirect);
    } else {
      this.update(redirect);
    }
    return false;
  }

  add(redirect: boolean) {
    this.reviewsDataService.updateReview(this.review).subscribe((data: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('REVIEWUPDATED')});
      if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
        this.dynamicDialogRef.close({refresh: true});
      } else if (redirect) {
        this.list();
      }
    }, (error: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('REVIEWNOTUPDATED') + ' ' + error.message});
      console.warn(error);
    });
  }

  update(redirect: boolean) {
    this.reviewsDataService.addReview(this.review).subscribe((data: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('REVIEWCREATED')});
        if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
          this.dynamicDialogRef.close({refresh: true});
        } else if (redirect) {
          this.list();
        }
      }, (error: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('REVIEWNOTCREATED') + ' ' + error.message});
        console.warn(error);
    });
  }

}

@Component({
  selector: 'app-review-form',
  templateUrl: './review-form.component.html',
  styleUrls: ['./review-form.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogReviewFormComponent extends ReviewFormComponent {
}

